/* eslint-disable react/jsx-wrap-multilines */
import React, {useEffect, useRef, useState} from 'react';
import {Controller, SubmitHandler, useForm, useWatch} from 'react-hook-form';
import {
    Autocomplete,
    Box,
    Button,
    CircularProgress,
    Dialog, DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Stack,
    TextField,
    Tooltip,
    Typography
} from '@mui/material';
import {yupResolver} from "@hookform/resolvers/yup";
import {InferType} from "yup";
import {LuoghiList, MinordList, OpzioniList, VersOre} from "./types";
import {
    useGetAttivita,
    useGetNodi,
    useGetProgettiByDip,
    useGetVersOre,
    useUpdateVersOre,
    validationSchemaVersOre
} from "./Services";
import {format} from "date-fns";
import ReportProg from "../reports/ReportProg";
import SummarizeIcon from "@mui/icons-material/Summarize";
import VersOreNoteAssist, {clampVersOreNote, loadVersOreCopilotConfig} from "./VersOreNoteAssist";


interface EditVersOreProps {
  onClose: () => void;
  id: number;
  isReadOnly: boolean;
}

// const AddVersOre  = ()  => {
const EditVersOre: React.FC<EditVersOreProps> = ({ onClose,id,isReadOnly }) => {


  const today = format(new Date(), 'yyyy-MM-dd');

  const {  data:  versore,  isError: isLoadingVersOreError, isFetching: isFetchingVersOre, isLoading: isLoadingVersOre, } = useGetVersOre(id);

const [openReport, setOpenReport] = useState(false);

   const [idprog, setIdProg] = useState('');
  const [idnodo, setIdNodo] = useState('');
  const [idatt, setIdAtt] = useState('');

const [molt, setMolt] = useState<number>(1);



  const [codprog, setCodProg] = useState('');
  const [codnodo, setCodNodo] = useState('');
  const [codatt, setCodAtt] = useState('');


  const [tiponodo, setTipoNodo] = useState('');


  const [ditta, setDitta] = useState('');



  const [opzione, setOpzione] = useState('');
  const [minord, setMinOrd] = useState(0);

  const [luogo, setLuogo] = useState('');


  const { mutateAsync: updateVersOre, isPending: isUpdatingVersOre } = useUpdateVersOre();

 const {  data: ProgettiApiResponse } = useGetProgettiByDip();





  type VersOreForm = InferType<typeof validationSchemaVersOre>;
  const { setValue, register,control, handleSubmit, formState: { errors },reset,watch} = useForm<VersOreForm>({ resolver: yupResolver(validationSchemaVersOre)});

const watchIdProg = watch('idprog');
// console.log('idprog:',idprog)



const { data: NodiApiResponse , refetch: refetchNodi } = useGetNodi(watchIdProg);
const { data: AttivitaApiResponse , refetch: refetchAttivita } = useGetAttivita(watchIdProg);


const watchOreStraord = useWatch({
  control,
  name: 'orestraord'
});

const watchMinStraord = useWatch({
  control,
  name: 'minstraord'
});

const watchLuogo = useWatch({
  control,
  name: 'luogo'
});

// useEffect(() => {
//   const ore = Number(watchOreStraord) || 0;
//   const minuti = Number(watchMinStraord) || 0;
//
//
//   let oreCalcolate = minuti > 0 ? ore + 1 : ore;
//
//   if (watchLuogo === 'TRASFERTA') {
//     oreCalcolate = oreCalcolate <= 4 ? 4 : 8;
//   }
//
//
//   setValue('oreord', oreCalcolate);
// }, [watchOreStraord, watchMinStraord, setValue]);

useEffect(() => {
  const ore = Number(watchOreStraord) || 0;
  const minuti = Number(watchMinStraord) || 0;
 const moltiplicatore = molt || 1;

  // console.log(molt);

  // 1️⃣ Converto tutto in minuti
  const minutiTotali = (ore * 60 + minuti) * moltiplicatore;

  // 2️⃣ Converto in ore arrotondate per eccesso
  let oreCalcolate = Math.ceil(minutiTotali / 60);

  // 3️⃣ Regola TRASFERTA applicata DOPO il calcolo
  if (watchLuogo === 'TRASFERTA') {
    oreCalcolate = oreCalcolate <= 4 ? 4 : 8;
  }

  setValue('oreord', oreCalcolate);
}, [watchOreStraord, watchMinStraord, watchLuogo, molt, setValue]);




useEffect(() => {
  if (versore) {


    // Trim and process necessary values
    const codProg = (versore?.codprog || '').trim();
    const codNodo = (versore?.codnodo || '').trim();
    const codAtt = (versore?.codatt || '').trim();
    const ditta = versore?.ditta || 0;


    const Luogo = (versore?.luogo || '').trim();

    const Opzione = (versore?.opzione || '').trim();
    const minOrd = (versore?.minord || 0);

    // Compute values
    const idProg = `${ditta}-${codProg}`;
    const idNodo = `${ditta}-${codProg}-${codNodo}`;
    const idAtt = `${ditta}-${codProg}-${codAtt}`;

    // Update local state
    setIdProg(idProg);
    setIdNodo(idNodo);
    setIdAtt(idAtt);

    setCodProg(codProg);

    setOpzione(Opzione);
    setMinOrd(minOrd);
    setLuogo(Luogo);

    // Udpate form state because are calculated and not from versore
    reset({
      ...versore,
datareg: versore.datareg
    ? new Date(versore.datareg)
    : null,

  datains: versore.datains
    ? new Date(versore.datains)
    : null,

      idprog: idProg,
      idnodo: idNodo,
      idatt: idAtt,

    });
  }
}, [versore, reset]);



useEffect(() => {
  if (!versore || !ProgettiApiResponse?.results) return;

  const selectedProject = ProgettiApiResponse.results.find(
    p => p.codprog?.trim() === versore.codprog?.trim()
  );

  if (selectedProject?.molt != null) {
    const parsed = parseFloat(String(selectedProject.molt).replace(',', '.'));
    setMolt(parsed || 1);
  }
}, [versore, ProgettiApiResponse]);

const clickedButtonRef = useRef<string | null>(null);

// this sets the form state and  local state

const handleSelection = (setter: (value: any) => void, fieldName: any, value: any) => {
     // console.log('handleSelection called with:', value);
    if (value || value==0) {
         // console.log('Setting field:', fieldName, 'with value:', value);
        setValue(fieldName, value);
        setter(value);
    }
     // console.log('values of form ', watch());
};


  const handleButtonClick = (buttonId: string) => {
        clickedButtonRef.current = buttonId;
      };


 // const onSubmit: SubmitHandler<VersOre> = async (data) => {
 //
 //      if (clickedButtonRef.current === 'save') {
 //           data.indlavoraz = 0;
 //           data.indora = 0;
 //           data.indtipovers = 2;
 //           data.valutadqr = 'EURO';
 //           data.umtempodqr = 2;
 //           data.indtipocosdqr = 0;
 //           data.costodqr = 30;
 //           data.impdqr = 90;
 //           data.protocollo = 1037;
 //           data.coddip = localStorage.getItem('coddip') || '';
 //           await createVersOre(data);
 //           onClose();
 //       }
 //   };


    const onSubmit: SubmitHandler<VersOre> = async (data) => {

        if (clickedButtonRef.current === 'save') {
              const copilotConfig = await loadVersOreCopilotConfig();
              data.indlavoraz = 0;
              data.indora = 0;
              data.indtipovers = 2;
              data.valutadqr = 'EURO';
              data.umtempodqr = 2;
              data.indtipocosdqr = 0;
              data.costodqr = 30;
              data.impdqr = 90;
              data.protocollo = 1037;
              data.note = clampVersOreNote(data.note || '', copilotConfig.noteMaxLength).value;

        if (data.variante === '' || data.variante === null ) {   delete data.variante;};

        if (data.datareg) {
                    data.inizlav = data.datareg;
                    data.finelav = data.datareg;
                }



//attenzione codprog in data non è corretto non è nella form

        // console.log('datasent', data);

           await updateVersOre({
              ...data,
              codprog: codprog
            });
  onClose();

        }
    };


 const handleClose = () => {
            onClose();
          };



  return (

 // <Box sx={{mt: '100px' , ml:10, width: '75%'  }}>
      <>
    <Dialog onClose={onClose} open fullWidth maxWidth="sm">
         <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
                          <Typography variant="h5">Modifica</Typography>
                          {codprog && (
                              <Tooltip title="Report Nodi Progetto" arrow>
                                  <IconButton
                                    size="large"
                                    color="primary"
                                    onClick={() => setOpenReport(true)}
                                  >
                                    <SummarizeIcon sx={{ fontSize: 30 }} />
                                  </IconButton>
                              </Tooltip>
                               )}

            </DialogTitle>
    <DialogContent>
        <form onSubmit={handleSubmit(onSubmit)}>
            <Stack spacing={0.5} direction="column" alignItems="flex-start">

                {/* First Row: First Four Fields */}
                <Stack direction="row" spacing={2} sx={{ width: '100%' }}>
                    <Box sx={{ width: '33.33%' }}>
                        <Controller
                          name="datareg"
                          control={control}
                          render={({ field }) => (
                            <TextField
                              type="date"
                              label="Data"
                              fullWidth
                              margin="dense"
                              value={
                                field.value
                                  ? format(new Date(field.value), 'yyyy-MM-dd')
                                  : ''
                              }
                              onChange={(e) => {
                                field.onChange(
                                  e.target.value ? new Date(e.target.value) : null
                                );
                              }}
                              InputLabelProps={{ shrink: true }}
                            />
                          )}
                        />
                        <Typography variant="inherit" color="error">{errors.datareg?.message}</Typography>
                    </Box>
                    <Box sx={{ width: '33.33%' }}>
                      <Controller
                          name="datains"
                          control={control}
                          render={({ field }) => (
                            <TextField
                              type="date"
                              label="Data Ins."
                              fullWidth
                              margin="dense"
                              disabled
                              value={
                                field.value
                                  ? format(new Date(field.value), 'yyyy-MM-dd')
                                  : ''
                              }
                              onChange={(e) => {
                                field.onChange(
                                  e.target.value ? new Date(e.target.value) : null
                                );
                              }}
                              InputLabelProps={{ shrink: true }}
                            />
                          )}
                        />
                           <Typography variant="inherit" color="error">{errors.datains?.message}</Typography>
                    </Box>

                     <Box sx={{ width: '33.33%' }}>
                   <Controller
  name="opzione"
  control={control}
  render={({ field }) => {

    const selectedOption =
      OpzioniList.find((opt) => opt.id === field.value?.trim()) || null;



    return (


      <Autocomplete
        options={OpzioniList}
        getOptionLabel={(option) => option.label}
        value={selectedOption}
        onChange={(_, value) => {
          field.onChange(value ? value.id : '');
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            margin="dense"
            label="Seleziona Opzione"
            fullWidth
          />
        )}
      />
    );
  }}
/>


                        <Typography variant="caption" color="error">{errors.opzione?.message}</Typography>
                  </Box>
                    {/*<Box sx={{ width: '25%' }}>*/}
                    {/*    <TextField id="id" label="Nrrel" fullWidth margin="dense" {...register('id')} error={!!errors.id} />*/}
                    {/*    <Typography variant="caption" color="error">{errors.id?.message}</Typography>*/}
                    {/*</Box>*/}
                    {/*<Box sx={{ width: '25%' }}>*/}
                    {/*    <TextField id="variante" label="Nrrel.Rif" fullWidth margin="dense" {...register('variante')} error={!!errors.variante} />*/}
                    {/*    <Typography variant="caption" color="error">{errors.variante?.message}</Typography>*/}
                    {/*</Box>*/}
                </Stack>

                {/* Next fields: Remaining fields */}
                <Box sx={{ width: '100%' }}>
                 <Controller
                          name="idprog"
                          control={control}
                          render={({ field }) => (
                            <Autocomplete
                              options={ProgettiApiResponse?.results ?? []}
                              getOptionLabel={(option) => option.desprogblocco ?? ''}
                              value={
                                ProgettiApiResponse?.results?.find(
                                  (opt) => opt.idprog === field.value
                                ) || null
                              }
                          onChange={(_, value) => {
                    const newIdProg = value?.idprog || '';
                    const newCodProg = value?.codprog?.trim() || '';

  field.onChange(newIdProg);

  setIdProg(newIdProg);
  setCodProg(newCodProg);


  // reset dependent fields
  setIdNodo('');
  setIdAtt('');
  setCodNodo('');
  setCodAtt('');

  setValue('idnodo', '');
  setValue('idatt', '');

  if (value?.molt != null) {
    const parsed = parseFloat(String(value.molt).replace(',', '.'));
    setMolt(parsed || 1);
  }
}}
                              renderInput={(params) => (
                                <TextField {...params} margin="dense" label="Seleziona Progetto" fullWidth />
                              )}
                            />
                          )}
                        />
                </Box>
                <Box sx={{ width: '100%' }}>
                    <Autocomplete
                        disablePortal
                        id="idnodo"
                        value={NodiApiResponse?.results.find((item) => item.idnodo === idnodo) || null}
                        options={NodiApiResponse?.results ?? []}
                        onChange={(event, value) => {handleSelection(setIdNodo, 'idnodo', value?.idnodo);handleSelection(setTipoNodo, 'tiponodo', value?.tiponodo);handleSelection(setCodNodo, 'codnodo', value?.codnodo);}}
                        renderInput={(params) => <TextField {...params} margin="dense" label="Seleziona Nodo" fullWidth />}
                    />
                     <Typography variant="caption" color="error">{errors.idnodo?.message}</Typography>
                </Box>
                <Box sx={{ width: '100%' }}>
                    <Autocomplete
                        disablePortal
                        id="idatt"
                        value={AttivitaApiResponse?.results.find((item) => item.idatt === idatt) || null}
                        options={AttivitaApiResponse?.results ?? []}
                        onChange={(event, value) => {handleSelection(setIdAtt, 'idatt', value?.idatt);handleSelection(setCodAtt, 'codatt', value?.codatt);}}
                        renderInput={(params) => <TextField {...params} margin="dense" label="Seleziona Attivita" fullWidth />}
                    />
                    <Typography variant="caption" color="error">{errors.idatt?.message}</Typography>
                </Box>

                {/* Continue with the rest of the fields as they were */}
              {/* Second Row: Oreord, Minord, Opzione */}
                 <Stack direction="row" spacing={2} sx={{ width: '100%' }}>
                    {/*<Box sx={{ width: '33.33%' }}>*/}
                    {/*    <TextField id="orestraord" label="Ore Eff" fullWidth margin="dense" {...register('orestraord')} error={!!errors.oreord} />*/}
                    {/*    <Typography variant="caption" color="error">{errors.orestraord?.message}</Typography>*/}
                    {/*</Box>*/}
                       <Box sx={{ width: '33.33%' }}>
                   <Controller
                          name="orestraord"
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              type="number"
                              label="Ore Eff"
                              fullWidth
                              margin="dense"
                              error={!!errors.orestraord}
                            />
                          )}
                        />
                       </Box>
                    <Box sx={{ width: '33.33%' }}>
                   <Controller
                              name="minstraord"
                              control={control}
                              defaultValue={0}
                              render={({ field }) => (
                                <Autocomplete
                                  {...field}
                                  options={MinordList}
                                  getOptionLabel={(option) => option.label}
                                  value={
                                    MinordList.find((opt) => opt.id === field.value) || null
                                  }
                                  onChange={(_, value) => {
                                    field.onChange(value ? value.id : 0);
                                  }}
                                  renderInput={(params) => (
                                    <TextField {...params} margin="dense" label="Min Eff" fullWidth />
                                  )}
                                />
                              )}
                            />
                    </Box>
                     <Box sx={{ width: '33.33%' }}>
                        <TextField id="oreord" label="Ore" disabled={true} fullWidth margin="dense" {...register('oreord')} error={!!errors.oreord} />
                        <Typography variant="caption" color="error">{errors.oreord?.message}</Typography>
                    </Box>
                    {/*<Box sx={{ width: '33.33%' }}>*/}
                    {/*    <Autocomplete*/}
                    {/*    disablePortal*/}
                    {/*    id="minord"*/}
                    {/*    // value={minord}*/}
                    {/*    options={MinordList}*/}
                    {/*    getOptionLabel={(option) => option.label}*/}
                    {/*    onChange={(event, value) => {handleSelection(setMinOrd, 'minord', value?.id)}}*/}
                    {/*    renderInput={(params) => <TextField {...params} margin="dense" label="Seleziona Min Calc" fullWidth />}*/}
                    {/*    />*/}
                    {/*    <Typography variant="caption" color="error">{errors.minord?.message}</Typography>*/}
                    {/*</Box>*/}






                </Stack>

                <Box sx={{ width: '100%' }}>
                    <Controller
                        name="note"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                            <VersOreNoteAssist
                                textFieldId="note"
                                value={field.value || ''}
                                onChange={field.onChange}
                                error={!!errors.note}
                                helperText={errors.note?.message}
                                disabled={isReadOnly}
                            />
                        )}
                    />
                </Box>

                <Stack direction="row" spacing={2} sx={{ width: '100%' }}>
                     <Box sx={{ width: '50%' }}>
                       <Controller
                              name="luogo"
                              control={control}
                              render={({ field }) => (
                                <Autocomplete
                                  options={LuoghiList}
                                  getOptionLabel={(option) => option.label}
                                  value={
                                    LuoghiList.find((opt) => opt.id === field.value?.trim()) || null
                                  }
                                  onChange={(_, value) => {
                                    field.onChange(value?.id || '');
                                  }}
                                  renderInput={(params) => (
                                    <TextField {...params} margin="dense" label="Seleziona Luogo" fullWidth />
                                  )}
                                />
                              )}
                            />
                        <Typography variant="caption" color="error">{errors.luogo?.message}</Typography>
                    </Box>
                    <Box sx={{ width: '25%' }}>
                        <TextField id="km" label="Km" fullWidth margin="dense" {...register('km')} error={!!errors.km} />
                        <Typography variant="caption" color="error">{errors.km?.message}</Typography>
                    </Box>
                    <Box sx={{ width: '25%' }}>
                        <TextField id="trasf" label="Trasf" fullWidth margin="dense" {...register('trasf')} error={!!errors.trasf} />
                        <Typography variant="caption" color="error">{errors.trasf?.message}</Typography>
                    </Box>
                </Stack>
            </Stack>
            <Stack direction="row" justifyContent="flex-end" spacing={1} sx={{ marginTop: '15px' }}>
                <Button color="primary" type="reset" variant="outlined">CANCELLA</Button>
                <Button variant="contained" onClick={onClose} color="error">CHIUDI</Button>
                <Button id="save" type="submit" color="primary" variant="contained"
                        disabled={isUpdatingVersOre}
                        startIcon={isUpdatingVersOre ? <CircularProgress color="inherit" size={25} /> : null}
                        onClick={() => handleButtonClick('save')}>
                    SALVA
                </Button>
            </Stack>
        </form>

       {/*<Stack direction="row" justifyContent="flex-end" spacing={1} sx={{ marginTop: '15px' }}>*/}
       {/*{codprog && <ReportProg key={codprog} codprogprop={codprog} />}*/}
       {/*</Stack>*/}


    </DialogContent>
</Dialog>

 <Dialog
      open={openReport}
      onClose={() => setOpenReport(false)}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Report Nodi Progetto</DialogTitle>

      <DialogContent>
     <ReportProg
                  key={watchIdProg}
                  idprogprop={watchIdProg}
                />
      </DialogContent>

      <DialogActions>
        <Button onClick={() => setOpenReport(false)}>Chiudi</Button>
      </DialogActions>
    </Dialog>

  </>



  );
};

export default EditVersOre;
